import type { UpcomingTrip } from '../types'

export const upcomingTripColumns = [
  'Time',
  'Booking ID',
  'Service',
  'Date',
  'Customer',
  'Status',
] as const

export const upcomingTrips: UpcomingTrip[] = [
  {
    id: 'trip-1',
    time: '9.00 AM',
    bookingId: 'SC-1250',
    service: 'Airport Transfer',
    date: '17 Jun',
    customer: 'John Smith',
    status: 'in-progress',
  },
  {
    id: 'trip-2',
    time: '10.00 AM',
    bookingId: 'SC-1250',
    service: 'Hallstatt Tour',
    date: '19 Jun',
    customer: 'Judy David',
    status: 'confirmed',
  },
  {
    id: 'trip-3',
    time: '10.00 AM',
    bookingId: 'SC-1250',
    service: 'Hallstatt Tour',
    date: '19 Jun',
    customer: 'Judy David',
    status: 'cancelled',
  },
  {
    id: 'trip-4',
    time: '9.00 AM',
    bookingId: 'SC-1250',
    service: 'Airport Transfer',
    date: '17 Jun',
    customer: 'John Smith',
    status: 'cancelled',
  },
]
